import { camelCase } from 'lodash'
import * as Yup from 'yup'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'

type Values = {
  id: number
  columns: number
  headingObjectStyleSettingType: string
  name: string
}

type EnumValues = {
  headingObjectStyleSettingTypes: Record<string, string>
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  enumValues: EnumValues
  isSettingWritable: boolean
  rowIndex: number
}

const _HeadingObjectStyleSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleSubmit,
  enumValues,
  isSettingWritable,
  rowIndex
}: Props) => {
  if (!values) {
    return <></>
  }
  const columnString = values?.columns === 0 ? '' : `${values?.columns}段`
  const typeString = enumValues.headingObjectStyleSettingTypes[camelCase(values?.headingObjectStyleSettingType)]
  const combinedColumnString = `${columnString}${typeString}`
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={2}>{combinedColumnString}</Col>
      <Col sm={3}>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id={`nameInput-${values.id}`}
            type='text'
            name='name'
            value={values.name || ''}
            disabled={!isSettingWritable}
            onChange={handleChange}
            onBlur={(_) => handleSubmit(values)}
            isInvalid={!!(touched.name && errors.name)}
          />
          <Form.Control.Feedback type='invalid'>{errors.name}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const HeadingObjectStyleSettingForm = Object.assign(_HeadingObjectStyleSettingForm, {
  schema: Yup.object().shape({
    name: Yup.string().trim().required()
  })
})
